import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fc4ddbde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "faqs-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title text-center" }, "Frequently Asked Questions", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "section-subtitle text-center mb-5" }, "Everything you need to know about JobBuddy", -1))
const _hoisted_5 = { class: "faqs-container" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.faqs, (faq, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "faq-item"
          }, [
            _createElementVNode("button", {
              class: _normalizeClass(["faq-question", { active: $setup.activeIndex === index }]),
              onClick: ($event: any) => ($setup.toggleFaq(index))
            }, [
              _createTextVNode(_toDisplayString(faq.question) + " ", 1),
              _createElementVNode("i", {
                class: _normalizeClass(["bi", $setup.activeIndex === index ? 'bi-chevron-up' : 'bi-chevron-down'])
              }, null, 2)
            ], 10, _hoisted_6),
            _createElementVNode("div", {
              class: _normalizeClass(["faq-answer", { active: $setup.activeIndex === index }])
            }, [
              _createElementVNode("p", null, _toDisplayString(faq.answer), 1)
            ], 2)
          ]))
        }), 128))
      ])
    ])
  ]))
}